import type { SkillGroup } from '@/types';

export const SKILL_GROUPS: SkillGroup[] = [
  {
    label: 'Qualité & Inspection',
    skills: [
      { name: 'Qualité ISO 9001 · PRIE · ITP · NCR',            percentage: 93, colorVar: 'var(--color-anticiper)' },
      { name: 'Inspection · GD&T · Hexagon · CMM · FARO',       percentage: 90, colorVar: 'var(--color-anticiper)' },
      { name: 'Coordination NDT · UT · MT · PT',                percentage: 88, colorVar: 'var(--color-maitrise)' },
      { name: 'Normes ASME · ASTM · ISO',                       percentage: 87, colorVar: 'var(--color-maitrise)' },
      { name: 'Contrôle peinture · soudure · traitement thermique', percentage: 84, colorVar: 'var(--color-piloter)' },
    ],
  },
  {
    label: 'Intelligence Artificielle',
    skills: [
      { name: 'Agents IA · RAG · Contexte métier',              percentage: 94, colorVar: 'var(--color-temps)' },
      { name: 'Claude API · Gemini API · LLMs locaux',          percentage: 91, colorVar: 'var(--color-temps)' },
      { name: 'Prompt engineering · Instructions structurées',  percentage: 89, colorVar: 'var(--color-maitrise)' },
      { name: 'Automatisation qualité · Workflows IA',          percentage: 88, colorVar: 'var(--color-maitrise)' },
      { name: 'Développement React + Firebase (IA-assisté)',    percentage: 85, colorVar: 'var(--color-ciel)' },
    ],
  },
  {
    label: 'Gestion de Projet & Coordination',
    skills: [
      { name: 'Coordination multi-métiers : usinage · soudure · sablage · peinture', percentage: 90, colorVar: 'var(--color-ameliorer)' },
      { name: 'Réhabilitation de pièces hydroélectriques et métallurgiques', percentage: 88, colorVar: 'var(--color-ameliorer)' },
      { name: 'GMAO · Maintenance intégrée ERP · Planification', percentage: 88, colorVar: 'var(--color-piloter)' },
      { name: 'Amélioration continue · 5S · AMDEC · Pareto',    percentage: 86, colorVar: 'var(--color-piloter)' },
      { name: 'Points d\'arrêt clients en anglais : Hydro-Québec · GE · Andritz', percentage: 85, colorVar: 'var(--color-ciel)' },
    ],
  },
  {
    label: 'Outils & Développement',
    skills: [
      { name: 'KPI · PowerBI · Excel avancé',                   percentage: 88, colorVar: 'var(--color-ameliorer)' },
      { name: 'ERP : Notixia · Genius',                         percentage: 87, colorVar: 'var(--color-temps)' },
      { name: 'Python · PowerApps · Automatisation',            percentage: 83, colorVar: 'var(--color-ciel)' },
      { name: 'CAO : SolidWorks · SolidEdge · CATIA V5/V6',     percentage: 82, colorVar: 'var(--color-piloter)' },
      { name: 'MS Project · Gantt · Kanban',                    percentage: 82, colorVar: 'var(--color-anticiper)' },
    ],
  },
];
